<template>
  <div>
    <h2 class="text-primary-dark seccion">
      Mis recibos
    </h2>
    <lista-recibos-agrupados :recibos="recibos" :loading="loading" @recibo-seleccionado="goToRecibo($event)"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import LogoCia from '@/components/widgets/LogoCia'
import ListaRecibosAgrupados from '@/components/widgets/recibos/ListaRecibosAgrupados'

export default {
  data() {
    return {
      loading: false,
      sortKey: 'poliza.fechaVencimiento',
      reverse: true,
      valorBoton: '',
      apellido1: ''
    }
  },
  computed: {
    ...mapGetters({
      recibos: 'recibos',
      urlBase: 'urlBase',
      credentials: 'credentials',
      estados: 'estados',
      recibosAnulados: 'recibosAnulados'
    })
  },
  mounted() {
    this.loadRecibos();
  },
  methods: {
    loadRecibos() {
      if (this.recibos == 0) { 
        this.loading = true;
      }
      let estados = this.recibosAnulados ? [1,2,3,4,5,6] : [1,2,5,6]
      let grupos = [
        'recibo.poliza',
        'poliza.cliente',
        'poliza.producto',
        'poliza.riesgos',
        'poliza.compania',
        'producto.ramo',
        'poliza.recibo',
        'riesgoPoliza.riesgo',
        'recibo.situacionRecibo'
      ]
      let payload = {
        params: {
          'grupos': grupos.join(','),
          'dentroEfectoPoliza': 'true',
          'polizasVigor': 'true',
          'page': 1,
          'limit': 50,
          'sort': 'recibo.efecto',
          'inverse': 'true',
          'situaciones': estados.join(',')
        },
        callbackOk: (responses) => {
          this.loading = false
        },
        callbackError: (error) => {
          this.loading = false;
          if (error.status === 401) {
            this.$router.push({name:'Login'});
          }
        }
      }
      this.$store.dispatch("loadRecibos", payload);
    },
    goToRecibo(recibo) {
      this.$router.push({ name: 'recibo', params: { id: recibo.id }});
    }
  },
  components: {
    Loading,
    LogoCia,
    ListaRecibosAgrupados
  }
}
</script>